// src/LandingPage.js
import React from 'react';
import './LandingPage.css'; // Keep for background and .centered-logo styles
import { Box } from '@mui/material';
import { useAppTheme } from './contexts/ThemeContext';

function LandingPage() {
  const { currentTheme } = useAppTheme();
  const isSubmarineTheme = currentTheme === 'submarine';

  return (
    // Main container - keep using className for background if defined there
    // Or apply background via sx prop on this Box
    <Box
      className="landing-container" // Keep if background is set here
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        // If background isn't in CSS, add it here:
        // background: 'radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%)',
      }}
    >
      {/* NavBar is now rendered in App.js */}

      {/* Centering Container using MUI Box and sx prop */}
      <Box
        sx={{
          flexGrow: 1, // Take available vertical space
          width: '100%', // Ensure it takes full width
          display: 'flex',
          flexDirection: 'column', // Stack logo/text vertically if needed
          justifyContent: 'center', // Center content horizontally
          alignItems: 'center', // Center content vertically
          padding: '2rem', // Add padding
          boxSizing: 'border-box', // Include padding in size calculation
          overflow: 'hidden', // Prevent scrollbars if logo slightly too big
        }}
      >
        {/* The Logo */}
        <Box className="centered-logo-wrapper">
          <img
            src={isSubmarineTheme ? "/FullLogo_Transparent_NoBuffer-2.png" : "/FullLogo_Transparent_NoBuffer.png"}
            alt="Denver Dispatch Logo"
            className="centered-logo"
          />
        </Box>
        {/* Optional Text */}
        {/* <h1 className="landing-title">DENVER DISPATCH</h1> */}
      </Box>
    </Box>
  );
}

export default LandingPage;
